import { SERVER_METHODS, requestServer } from "./request";

export const UJAvailableLocation = async (payload) => {
  try {
    let path = "/auth";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const trackUserJourney = async (payload) => {
  try {
    let path = "/public/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, {
      data: { ...payload },
      api_name: "platform_tracker",
    });
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const companyRegistration = async (payload) => {
  try {
    let path = "/auth";
    let res = await requestServer(SERVER_METHODS.POST, path, {
      data: { ...payload },
      api_name: "uj_register_new_client",
    });
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAPINews = async (payload) => {
  try {
    let path = "/public/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};
export const getGlobalRisksData = async (payload) => {
  try {
    let path = "/public/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getMarketResearchData = async (payload) => {
  console.log("payload-->", payload);
  try {
    const path = "/public/genericapi";
    const res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};
